import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {SubmissionError} from 'redux-form'
import {loginUser} from 'redux/modules/currentUser/actions'
import Link from 'components/Link'
import SignInForm from './SignInForm'

class SignIn extends React.Component {
  static propTypes = {
    location: PropTypes.object
  }

  render() {
    const {location} = this.props
    const query = location.query || {}
    const initialValues = {
      email: query.email
    }

    return (
      <div className='auth-view_content is-single'>
        <div className='auth-view_panel is-login'>
          <div className='auth-view_panel_body'>
            <SignInForm initialValues={initialValues} onSubmit={this.onSubmit} />
            <p className='auth-view_panel_text is-login'>Forgot your password?</p>
            <p className='auth-view_panel_text is-login'>
              <Link className='auth-view_panel_text_link' to='/forgot'>Restore</Link>
            </p>
          </div>
        </div>
      </div>
    )
  }

  onSubmit = (creds, dispatch) => new Promise((resolve, reject) => {
    dispatch(loginUser(creds))
      .success(resolve)
      .fail(error => {
        reject(new SubmissionError({_error: error}))
      })
  })
}

const mapStateToProps = state => ({})
const mapDispatchToProps = null

export default connect(mapStateToProps, mapDispatchToProps)(SignIn)



// WEBPACK FOOTER //
// ./client/views/AuthView/SignIn.js